import type { IconDefinition } from '../index.tsx';

export const iconRefresh: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconRefresh',
  icon: [
    16,
    16,
    [],
    '',
    'M14.4333 0.784428L12.8333 2.41776C11.5333 1.25109 9.83333 0.517761 8 0.517761C4.83333 0.517761 2.06667 2.55109 1.1 5.55109C0.933333 6.11776 1.23333 6.71776 1.8 6.88443C2.36667 7.05109 2.96667 6.75109 3.13333 6.18443C3.8 4.08443 5.76667 2.65109 8 2.65109C9.23333 2.65109 10.4333 3.15109 11.3333 3.91776L9.83333 5.38443C9.3 5.95109 9.66667 6.91776 10.4667 6.91776H15.3667C15.7 6.91776 16 6.65109 16 6.28443V1.45109C16 0.617761 15 0.217761 14.4333 0.784428ZM14.1667 9.11776C13.6 8.95109 13 9.25109 12.8333 9.81776C12.1667 11.9178 10.2 13.3178 8 13.3178C6.73333 13.3178 5.56667 12.8511 4.63333 12.0844L6.13333 10.5844C6.66667 10.0511 6.3 9.08443 5.5 9.0511H0.6C0.266667 9.08443 0 9.3511 0 9.71776V14.5511C0 15.3844 0.966667 15.7844 1.53333 15.2178L3.13333 13.5844C4.43333 14.7511 6.13333 15.4511 7.96667 15.4511C11.1 15.4511 13.8667 13.4511 14.8333 10.4511C15.0333 9.88443 14.7333 9.28443 14.1667 9.11776Z',
  ],
};
